import React from 'react';
import PropTypes from 'prop-types';
// import/no-extraneous-dependencies
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';
import './pagination.scss';
// import/no-extraneous-dependencies
const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    // siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    // siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const lastPage = paginationRange[paginationRange.length - 1];
  return (
    <ul
      className={classnames('pagination-container', { [className]: className })}
    >
      {/* left navigation arrow */}

      <button
        type="button"
        className={classnames('pagination-item', {
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        <div className="arrow left" />
      </button>
      {paginationRange.map((pageNumber) => {
        if (pageNumber === DOTS) {
          // eslint-disable-next-line react/jsx-key
          return <li className="pagination-item dots">&#8230;</li>;
        }

        return (
        // eslint-disable-next-line react/jsx-key
          <button
            type="button"
            className={classnames('pagination-item', {
              selected: pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </button>
        );
      })}
      <button
        type="button"
      // eslint-disable-next-line react/jsx-key
        className={classnames('pagination-item', {
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        <div className="arrow right" />
      </button>
    </ul>
  );
};

export default Pagination;

Pagination.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  // siblingCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,

};

// Pagination.propTypes = {
//     itemsDisplaying: PropTypes.number.isRequired,
//     items: PropTypes.number.isRequired,
//     itemsPerPage: PropTypes.number.isRequired,
//     handleNext: PropTypes.func.isRequired,
//     handlePrevious: PropTypes.func.isRequired,
//   };
